<template>
    <ToggleSimple ref="toggleComponent" @update:open="toggleOpen = $event" :default="defaultToggle">
        <template #toggle>
            <div class="left">
                <div v-if="$te(`fields.${name}.label`)" class="toggle-text">
                    {{ $t(`fields.${name}.label`) }}
                    <span v-if="isActive">
                        <div class="icon-check-dark"></div>
                    </span>
                </div>
                <div v-if="$te(`fields.${name}.description`)" class="toggle-description">
                    {{ $t(`fields.${name}.description`) }}
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <div :class="cssClassOptions">
                <CustomSelectDateRange
                    :modelValue="modelValue"
                    :inputKey="name"
                    @update:modelValue="onChanged"
                    optionsType="long"
                />
            </div>
        </template>
    </ToggleSimple>
</template>

<script>
    import ToggleSimple from '@/components/elements/misc/ToggleSimple';
    import CustomSelectDateRange from '@/components/elements/inputs/CustomSelectDateRange';

    export default {
        name: "OptionsVisitDate",
        components: {
            ToggleSimple,
            CustomSelectDateRange
        },
        props: {
            modelValue: {
                type: Object,
                default: () => ({ min: null, max: null, custom: 'custom' })
            },
            defaultVal: {
                type: Object,
                default: () => ({ min: null, max: null, custom: 'custom' })
            },
            defaultToggle: {
                type: Boolean,
                default: false
            },
            showDescriptions: {
                type: Boolean,
                default: true
            },
            cssClassOptions: {
                type: String,
                default: 'options-type-4'
            }
        },
        data() {
            return {
                name: 'prospects_filter_created_alt',
                toggleOpen: this.defaultToggle
            };
        },
        computed: {
            isActive() {
                return JSON.stringify(this.modelValue) !== JSON.stringify(this.defaultVal) && this.modelValue.custom !== 'all' && !(this.modelValue.custom === 'custom' && !this.modelValue.min && !this.modelValue.max);
            }
        },
        methods: {
            resetSection(event = null) {
                if (event) {
                    event.stopPropagation()
                }
                this.$emit('update:modelValue', this.defaultVal);
            },
            onChanged(newValue) {
                this.$emit('update:modelValue', newValue);
            }
        }
    }
</script>